import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import CustomRangepicker from "../../common/rangepicker";
import StatusFilter from "../../common/statusFilter";
import { showFilterlistCms } from "../../../../utils/Constants";
import { TrimText, formateDateWithMonth } from "../../../../utils/commonfunction";
import * as userSubscriptionServices from "../../services/userSubscription.services";
import { useTranslation } from "react-i18next";

const UserSubscriptionTable = () => {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [resetdate, setResetDate] = useState(false);
  const [statsupdate, setStatusUpdate] = useState("false");

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_subscribe"), url: "/admin/subscriptionManagement/list/1" },
    { title: t("sidebar_link_user_subscriptions"), url: "" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", params.pgno);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);
      userSubscriptionServices
        .List(formData)
        .then((data) => {
          setDataLength(data?.data?.total_records);
          setList(data?.data?.list ?? []);
          setLoader(false);
        })
        .catch((error) => {
          console.log("error ====> ", error);
          setLoader(false);
        });
    }, 300);

    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch]);

  const viewFunction = (row) => {
    navigate(`/admin/userSubscriptions/view/${row._id}`);
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column };
    sort.order = e.target.classList.contains("assc") ? -1 : 1;
    setSorting(sort);
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("sidebar_link_user_subscriptions")}</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => prepareSearch("createdAt", e)}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    className="cp"
                    data={showFilterlistCms}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered border-t0 card-table text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="sr_head">{t("list_heading_sno")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_name")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="user.full_name" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_email")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="user.email" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_title")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="title" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_price")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="paid_amount" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_duration_type")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="duration_type" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Start Date</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="start_date" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>End Date</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="end_date" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_created_date")}</span>
                        <Sorting
                          sort={sorting}
                          defaultSorting={defaultSorting}
                          handleSort={handleSort}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    <th className="status_head">{t("list_heading_status")}</th>
                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={11}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => (
                          <tr key={row._id}>
                            <td>{(page - 1) * itemperpage + i + 1}</td>
                            <td>
                              {row?.user?.full_name
                                ? TrimText(row.user.full_name, 30)
                                : row?.user?.first_name
                                ? TrimText(
                                    `${row.user.first_name} ${row.user.last_name || ""}`.trim(),
                                    30
                                  )
                                : "N/A"}
                            </td>
                            <td>{row?.user?.email ? TrimText(row.user.email, 35) : "N/A"}</td>
                            <td>{row?.title ? TrimText(row.title, 30) : "N/A"}</td>
                            <td>{row?.paid_amount !== undefined && row?.paid_amount !== null ? `$${row.paid_amount}` : "N/A"}</td>
                            <td className="text-capitalize">{row?.duration_type || "N/A"}</td>
                            <td>{row?.start_date ? formateDateWithMonth(row.start_date) : "N/A"}</td>
                            <td>{row?.end_date ? formateDateWithMonth(row.end_date) : "N/A"}</td>
                            <td>{row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                            <td>
                              <span
                                className={`badge ${
                                  row?.activated ? "badge-success" : "badge-danger"
                                }`}
                              >
                                {row?.activated ? "Active" : "Inactive"}
                              </span>
                            </td>
                            <td>
                              <button
                                className="btn ripple btn-main-primary signbtn"
                                onClick={() => viewFunction(row)}
                              >
                                {t("btn_view")}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={11} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>

            <div role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ?? "0"}
              </b>
            </div>

            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                setPage={setPage}
                currentPage={page}
                pageRoute={[
                  { name: "UserSubscriptionTable", path: "/admin/userSubscriptions/list" },
                ]}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSubscriptionTable;
